import { AppraiserActionType } from '../AppraiserConstants';
import { appraiserActions } from '@apply/adminStore';

export const executeAppraiserAction = (itemData, dispatch) => {
    const onModify = (appraiserId) => {
        dispatch(
            appraiserActions.setAppraiserModal({
                appraiserModal: { isOpen: true, appraiserId: appraiserId },
            })
        );
    };

    const onDelete = (appraiserId) => {
        dispatch(
            appraiserActions.setDeleteAppraiserModal({
                deleteAppraiserModal: { isOpen: true, appraiserId },
            })
        );
    };

    const onRestore = (appraiserId) => {
        dispatch(
            appraiserActions.setRestoreAppraiserModal({
                restoreAppraiserModal: { isOpen: true, appraiserId },
            })
        );
    };

    const onNotImplemented = () => {
        alert('Not Implemented yet!');
    };

    switch (itemData.id) {
        case AppraiserActionType.Modify:
            onModify(itemData.appraiserId);
            break;
        case AppraiserActionType.Delete:
            onDelete(itemData.appraiserId);
            break;
        case AppraiserActionType.Restore:
            onRestore(itemData.appraiserId);
            break;
        default:
            onNotImplemented();
            break;
    }
};
